import { reactive } from 'vue';

import {
    clients,
    ProductFilter,
    ProductStatusType,
    IProductRunClient,
    Paging,
    SearchResultOfProductFilterAndProductSearchResult,
    Sorting,
    ProductProcessDefinition,
    ProductGroup,
} from '@/api';
import { stores } from '@/store';
import { IProductRunStore } from '@/store/productRun.store';
import { IProductProcessDefinitionStore } from '@/store/productProcessDefinition.store';

export class ProductListService {
    public state: SearchResultOfProductFilterAndProductSearchResult = reactive({
        filter: {},
        results: [],
        paging: {},
        sorting: {},
    });

    constructor(
        private productClient: IProductRunClient,
        private productStore: () => IProductRunStore,
        private definitionStore: () => IProductProcessDefinitionStore,
    ) {}

    get definitions(): ProductProcessDefinition[] {
        return this.definitionStore().definitions;
    }
    get statusses(): ProductStatusType[] {
        return this.productStore().statusses;
    }
    get productGroups(): ProductGroup[] {
        return this.productStore().productGroups;
    }

    get filter(): ProductFilter {
        return this.state.filter || {};
    }

    async search(
        filter: ProductFilter = {},
        sorting: Sorting = {},
        paging: Paging = { pageNumber: 1, pageSize: 10 },
    ): Promise<void> {
        const results = await this.productClient.getAll(
            filter.definition,
            filter.versionDescription,
            filter.startExecutionFrom,
            filter.startExecutionTo,
            filter.status,
            filter.isDryRun,
            filter.productGroupLabel,
            sorting.by,
            sorting.descending,
            paging.pageNumber,
            paging.pageSize,
        );

        Object.assign(this.state, results);
    }

    async init(): Promise<void> {
        await this.definitionStore().fetchDefinitions();
        await this.productStore().fetchStatusses();
        await this.productStore().fetchProductGroups();
    }
}

export const ProductListServiceInstance = new ProductListService(
    clients.ProductRunClient,
    stores.ProductStore,
    stores.ProductProcessDefinitionStore,
);
